import { useEffect, useState } from "react";

export const DITHER_COLORS = {
  light: {
    wave: [0.75, 0.75, 0.75] as [number, number, number],
    bg: [0.98, 0.98, 0.98] as [number, number, number],
  },
  dark: {
    wave: [0.03, 0.03, 0.03] as [number, number, number],
    bg: [0, 0, 0] as [number, number, number],
  },
};

export function useDarkMode(): boolean {
  const [isDark, setIsDark] = useState(
    () => document.documentElement.getAttribute("data-theme") === "dark",
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.getAttribute("data-theme") === "dark");
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });
    return () => observer.disconnect();
  }, []);

  return isDark;
}
